import { GangParticipantWithRole } from '../types/gangCreationTypes';
import {
  CreateGangMemberRequest,
  CreateGangRequest,
  UpdateGangRequest,
} from '../api/gangsApi';

export const mapParticipantToRequest = (
  participant: GangParticipantWithRole,
  isEqualSplit: boolean
): CreateGangMemberRequest => {
  const baseRequest = {
    userId: participant.userId,
    isLeader: participant.role === 'leader',
    canSeeSplit: participant.canSeeSplit,
  };

  // Only send the fields relevant to the payment type
  if (participant.paymentType === 'percentage') {
    return {
      ...baseRequest,
      // When IsEqualSplit is true, don't send percentage - backend will calculate
      // Form uses 0-100 format (33.3), API expects 0-1 format (0.333)
      // Round to 3 d.p. after division (e.g., 33.3 / 100 = 0.333)
      defaultSplitPercentage: isEqualSplit
        ? undefined
        : participant.defaultSplitPercentage !== undefined &&
            participant.defaultSplitPercentage !== null
          ? Math.round((participant.defaultSplitPercentage / 100) * 1000) / 1000
          : undefined,
    };
  } else {
    // fixedRate - round to 2 d.p.
    return {
      ...baseRequest,
      defaultRate:
        participant.defaultRate !== undefined &&
        participant.defaultRate !== null
          ? Math.round(participant.defaultRate * 100) / 100
          : undefined,
      defaultUnitsValue:
        participant.defaultUnitsValue !== undefined &&
        participant.defaultUnitsValue !== null
          ? Math.round(participant.defaultUnitsValue * 100) / 100
          : undefined,
    };
  }
};

export const buildCreateGangRequest = (
  name: string,
  isEqualSplit: boolean,
  members: GangParticipantWithRole[]
): CreateGangRequest => {
  return {
    name,
    isEqualSplit,
    members: members.map(m => mapParticipantToRequest(m, isEqualSplit)),
  };
};

export const buildUpdateGangRequest = (
  gangId: string,
  name: string,
  isEqualSplit: boolean,
  members: GangParticipantWithRole[]
): UpdateGangRequest => {
  return {
    gangId,
    name,
    isEqualSplit,
    members: members.map(m => mapParticipantToRequest(m, isEqualSplit)),
  };
};
